module.exports = __webpack_public_path__ + "static/media/notice_step3_img.607eb302.png";